const Banner = () => {
  return (
    <div class="contact-us-banner corzo-page-title-wrap  corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr d-flex flex-column align-items-center">
          <h1
            class="corzo-page-title"
            style={{
              fontSize: "46px",
              marginTop: "10px",
              textTransform: "none",
            }}
          >
            Contact Us
          </h1>
          <div
            class="corzo-page-caption"
            style={{ marginTop: "20px", fontSize: "20px" }}
          >
            Get In Touch
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
